import React from 'react';

export function StoreLocatorLocationWarningYodel({message}) {
  return(
    <div className="store-location-warning-yodel">
      <p>{message}</p>
    </div>
  );
}


export function StoreLocatorLocationWarning({message}) {
  return(
    <div className="store-location-warning">
      <p>{message}</p>
    </div>
  );
}
